import axios from 'axios';
import { EXPORT_SUCCESS_MESSAGE, EXPORT_ERROR_MESSAGE } from '../config/export-contacts';

export default {
    namespaced: true,
    state: {
      showContactExportDrawer: false,
      contactsExportSnackbarMessage: '',
      showContactsExportSnackbarMessage: false,
      isLoading: false,
      isStaticList: false,
      staticListId: null,
      isExportHistoryLoading: false,
      exportHistoryFiles: [],
      totalFiles: 0,
    },
    mutations: {
      setShowContactExportDrawer(state, value) {
        state.showContactExportDrawer = value;
      },
      setContactsExportSnackbarMessage(state, value) {
        state.contactsExportSnackbarMessage = value;
      },
      setShowContactsExportSnackbarMessage(state, value) {
        state.showContactsExportSnackbarMessage = value;
      },
      setIsLoading(state, value) {
        state.isLoading = value;
      },
      setIsStaticList(state, value) {
        state.isStaticList = value;
      },
      setStaticListId(state, value) {
        state.staticListId = value;
      },
      setIsExportHistoryLoading(state, value) {
        state.isExportHistoryLoading = value;
      },
      setExportHistoryFiles(state, value) {
        state.exportHistoryFiles = value;
      },
      setTotalFiles(state, value) {
        state.totalFiles = value;
      },
    },
    actions: {
      async initContactExport({ commit, state, rootState, rootGetters }, { fileType, allColumns, isPrivate, csvCustomColumns, columnsOrder }) {
        try {
          commit('setIsLoading',true);
          const payload = {
            query: { ...rootGetters['contactsTable/queryParams'] },
            file_type: fileType,
            all_columns: allColumns,
            is_private: isPrivate,
            is_static_list: state.isStaticList,
            columns_order: columnsOrder
          };

          if (!allColumns) payload.custom_columns = csvCustomColumns;
          if (state.isStaticList) {
            const { data } = await axios.get(`${process.env.VUE_APP_API_BASE_URL}/static-lists/${state.staticListId}/contacts?$sort[created_at]=-1&$teams=false&$paginate=false`);
            const userId = rootState.ldAppLayout.userInfo.id;

            let staticListContacts = data.filter(contact => contact.owner_user_id === userId).map(contact => contact.id);
            payload.query = {
              ...payload.query,
              id: {
                $in: staticListContacts,
              },
            };
          }
          payload.query.$skip = 0;
          await axios({
            url: `${process.env.VUE_APP_CONTACTS_MS_BASE_URL}/export-contacts`,
            method: 'POST',
            data: payload,
          });

          commit('setContactsExportSnackbarMessage', EXPORT_SUCCESS_MESSAGE);
          commit('setShowContactsExportSnackbarMessage', true);
        } catch (err) {
          commit('contactsTable/setContactTableError', EXPORT_ERROR_MESSAGE, { root: true });
        } finally {
          commit('setIsLoading',false);
          commit('setShowContactExportDrawer',false);
        }
      },
      async getExportHistory({ commit }, page) {
        try {
          commit('setIsExportHistoryLoading',true);
          const limit = 10;
          const skip = page * limit;
          const response = await axios.get(`${process.env.VUE_APP_DOCUMENTS_API_BASE_URL}/export-files?$sort[dtCreated]=-1&$limit=${limit}&$skip=${skip}`);
          commit('setExportHistoryFiles', response.data.data);
          commit('setTotalFiles', response.data.total);
        } catch (err) {
          console.log(`error: ${JSON.stringify(err)}`);
          commit('contactsTable/setContactTableError', 'Get export history failed', { root: true });
        } finally {
          commit('setIsExportHistoryLoading',false);
        }
      },
    },
  };
